/* eslint-disable import/prefer-default-export */
export const getValidateReferralEndpoint = () =>
  'v1/subscriptions/validate_free_trial_referral';

export const getGrantTrialEndpoint = () => 'v2/subscriptions/trial/grant';
